export default __webpack_public_path__ + "static/media/bee123_login_pattern.34d10b01.png";